import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TranscriptViewerComponent } from './transcript-viewer.component';
import { NgxZeroStateModule } from '@go-modules/components/zero-state/zero-state.module';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FormatTimeModule } from '@go-modules/pipes/format-time/format-time.module';
import { TranscriptSearchComponent } from './transcript-search/transcript-search.component';
import { FormsModule } from '@angular/forms';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { EditTranscriptionSpeakersDialogModule } from '@go-modules/components/dialogs/edit-transcription-speakers-dialog/edit-transcription-speakers-dialog.module';
import { TeaseWallModule } from '@go-modules/directives/tease-wall/tease-wall.module';
import { GoSelectModule } from '@go-modules/directives/go-select/go-select.module';
import { BadgeModule } from '@go-modules/components/badge/badge.module';
import { JumpToCurrentTimeComponent } from '@go-modules/components/jump-to-current-time/jump-to-current-time.component';
import { FeedbackDisplayHeaderComponent } from '../feedback-display-header/feedback-display-header.component';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		NgxZeroStateModule,
		ScrollingModule,
		FormatTimeModule,
		FormsModule,
		GoMaterialModule,
		EditTranscriptionSpeakersDialogModule,
		TeaseWallModule,
		GoSelectModule,
		BadgeModule,
		JumpToCurrentTimeComponent,
		FeedbackDisplayHeaderComponent
	],
	exports: [
		TranscriptViewerComponent,
		TranscriptSearchComponent
	],
	declarations: [
		TranscriptViewerComponent,
		TranscriptSearchComponent
	]
})
export class TranscriptViewerModule {}
